var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5621 8.5275C14.8288 7.82417 15.838 7.82417 16.1055 8.5275L17.8305 13.3058C17.9513 13.6225 18.2588 13.8333 18.6021 13.8333H22.8413C23.6246 13.8333 23.9663 14.8083 23.3505 15.2858L20.3338 18C20.1987 18.1039 20.0999 18.2479 20.0517 18.4114C20.0035 18.5749 20.0083 18.7494 20.0655 18.91L21.1671 23.5792C21.4355 24.3292 20.5671 24.9733 19.9105 24.5117L15.813 21.9117C15.6727 21.8131 15.5053 21.7601 15.3338 21.7601C15.1623 21.7601 14.995 21.8131 14.8546 21.9117L10.7571 24.5117C10.1013 24.9733 9.23214 24.3283 9.50047 23.5792L10.6021 18.91C10.6593 18.7494 10.6641 18.5749 10.6159 18.4114C10.5677 18.2479 10.4689 18.1039 10.3338 18L7.31714 15.2858C6.70047 14.8083 7.0438 13.8333 7.82547 13.8333H12.0646C12.2316 13.8339 12.3947 13.7838 12.5325 13.6896C12.6703 13.5954 12.7762 13.4616 12.8363 13.3058L14.5613 8.5275H14.5621Z",
    stroke: "url(#paint0_linear_3410_9316)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3410_9316",
    x1: 22.3155,
    y1: 8,
    x2: 12.4078,
    y2: 18.3982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.6e9d9a2a.svg";
export { ForwardRef as ReactComponent };